import { EnvType } from '@shared-types';

export const getKalaOidcSettings = ({ env, spaAppUrl }: { env: EnvType; spaAppUrl: string }) => ({
	authority: env === EnvType.STAGE ? 'https://account-stg.emofid.com' : 'https://login.emofid.com',
	client_id: env === EnvType.PROD ? 'kala_pkce' : 'kala_pkce_test',
	redirect_uri: `${spaAppUrl}/auth-callback`,
	post_logout_redirect_uri: spaAppUrl,
	response_type: 'code',
	scope: 'easy2_api mts_api openid profile login_delegation-api',
	filterProtocolClaims: true,
	loadUserInfo: false,
	silent_redirect_uri: `${spaAppUrl}/silent-refresh.html`
});
